'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$FreightCost$() {
  this.aJD = null;
  this.aJE = false;
  this.aJx = null;
  this.aJy = false;
  this.aJz = null;
  this.aJA = false;
  this.aJB = null;
  this.aJC = false;
  this.aJF = null;
  this.aJG = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$FreightCost$ = this;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeBigDecimal__$init$__V(this);
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$FreightCost$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$FreightCost$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$FreightCost$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$FreightCost$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$FreightCost$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$FreightCost$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$FreightCost$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$FreightCost$.prototype = $p;
$p.o3 = (function() {
  if ((!this.aJE)) {
    this.aJD = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeBigDecimal$$anon$3(this);
    this.aJE = true;
  }
  return this.aJD;
});
$p.iq = (function() {
  if ((!this.aJy)) {
    this.aJx = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aJy = true;
  }
  return this.aJx;
});
$p.J2 = (function(x$0) {
});
$p.brQ = (function() {
  if ((!this.aJA)) {
    this.aJz = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lalleycats_Empty$$anon$1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => {
      var $x_1 = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$FreightCost$();
      var this$1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_package$().ox();
      var e$proxy9 = $x_1.iu(this$1.pp(0, this$1.hX));
      if ((e$proxy9 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalStateException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalStateException(), (("Expected Right, got Left(" + e$proxy9.bj) + ")"));
      }
      if ((e$proxy9 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        return e$proxy9.aI;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(e$proxy9);
    })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lalleycats_Empty$());
    this.aJA = true;
  }
  return this.aJz;
});
$p.afc = (function() {
  if ((!this.aJC)) {
    this.aJB = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Freight Cost";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aJC = true;
  }
  return this.aJB;
});
$p.bNT = (function() {
  if ((!this.aJG)) {
    this.aJF = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().Cc;
    this.aJG = true;
  }
  return this.aJF;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$FreightCost$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$FreightCost$, "app.data.data_point_types$package$FreightCost$", ({
  FK: 1,
  B: 1,
  C: 1,
  cz: 1,
  fX: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$FreightCost$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$FreightCost$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$FreightCost$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$FreightCost$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$FreightCost$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$FreightCost$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$FreightCost$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$FreightCost$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$FreightCost$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$FreightCost$ };
//# sourceMappingURL=app.data.data_point_types$package$-Freight-Cost$.js.map
